import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import Input from '../../../components/Library/Input';
import Label from '../../../components/Library/Label';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../../components/Library/Modal';
import InlineLoadingSpinner from '../../../components/LoadingSpinner/InlineLoadingSpinner';
import { User, useUsersApi } from '../../../middle_auth_api';

interface SettingsUserDetailsBodyProps {
  user: User;
  editMode: boolean;
  registerSave: (saveCallback:  () => Promise<User>) => void;
  unregisterSave: () => void;
}

const SettingsUserDetailsBody: React.FC<SettingsUserDetailsBodyProps> = (props) => {
  const usersApi = useUsersApi();
  const queryClient = useQueryClient();

  const [firstName, setFirstName] = useState(props.user.given_name as string)
  const [preferredName, setPreferredName] = useState(props.user.preferred_name as string ?? '')
  const [lastName, setLastName] = useState(props.user.family_name as string)
  const [enabled, setEnabled] = useState(props.user.enabled)
  const [email, setEmail] = useState(props.user.email as string ?? '')

  const save = async (): Promise<User> => {
    //const user = await usersApi.update_user_by_id()
    return props.user;
  };

  useEffect(() => {
    props.registerSave(save);
    return () => {
      props.unregisterSave();
    }
  }, []);

  useEffect(() => {
    if (!props.editMode) {
      setFirstName(props.user.given_name as string);
      setPreferredName(props.user.preferred_name as string ?? '');
      setLastName(props.user.family_name as string);
      setEnabled(props.user.enabled);
      setEmail(props.user.email as string ?? '');
    }
  }, [props.editMode])

  return <>
    <div className='p-4'>
      <div>
        <Label htmlFor='displayName'>Display Name</Label>
        <Input id='displayName' disabled readOnly value={`${preferredName.trim().length === 0 ? firstName : preferredName} ${lastName}`} />
      </div>
      <div>
        <Label htmlFor='firstName'>First Name</Label>
        <Input id='firstName' readOnly={!props.editMode} value={firstName} onChange={(e) => setFirstName(e.target.value)} className='w-full' />
      </div>
      {/* <div>
        <Label htmlFor='preferredName'>Preferred Name</Label>
        <Input id='preferredName' readOnly={!props.editMode} value={preferredName} onChange={(e) => setPreferredName(e.target.value)} className='w-full' />
      </div> */}
      <div>
        <Label htmlFor='lastName'>Last Name</Label>
        <Input id='lastName' readOnly={!props.editMode} value={lastName} onChange={(e) => setLastName(e.target.value)} className='w-full' />
      </div>
      <div>
        <Label htmlFor='email'>Email</Label>
        <Input id='email' readOnly={!props.editMode} value={email} onChange={(e) => setEmail(e.target.value)} className='w-full' />
      </div>
    </div>
  </>;
};

const SettingsUserDetails: React.FC = () => {
  const userApi = useUsersApi();
  const queryClient = useQueryClient()
  const navigate = useNavigate();

  const { userId } = useParams();

  const [editMode, setEditMode] = useState<boolean>(false);
  const [saveCallback, setSaveCallback] = useState<null | (() => Promise<User>)>(null);

  const userQuery = useQuery(['settings', 'user', userId], async () => {
    const user = await userApi.get_user_by_id({
      params: {
        id: userId!
      }
    });

    return user;
  });

  const saveUser = useMutation(async () => {
    if (saveCallback != null) {
      const user = await saveCallback();

      return user;
    }
  }, {
    onSuccess(data, variables, context) {
      if (data != null) {
        queryClient.setQueryData(['settings', 'user', data.id], data);
      }
    },
  });

  const closeModal = () => {
    navigate('..');
  }

  return <>
    <Modal show closeModal={closeModal}>
      <ModalHeader closeModal={closeModal}>{userQuery.data?.display_name ?? 'Loading...'}</ModalHeader>
      <ModalBody>
        {userQuery.data == null ? <InlineLoadingSpinner /> : <SettingsUserDetailsBody editMode={editMode} registerSave={setSaveCallback} unregisterSave={() => setSaveCallback(null)} user={userQuery.data} />}
      </ModalBody>
      <ModalFooter>

      </ModalFooter>
    </Modal>
  </>;
};

export default SettingsUserDetails